<template>
  <div class="content">
    <!-- 页头信息 -->
    <a-row class="page-head" type="flex" justify="space-between" align="top">
      <a-col :span="8">
        <div class="weather">
          <!-- 天气图 -->
          <!-- <img :src="`http://www.weather.com.cn/m2/i/icon_weather/29x20/${weatherImg[0]}`" alt=""> -->
          <!-- <span v-if="weatherImg[1]"> ~ </span> -->
          <!-- <img v-if="weatherImg[1]" :src="`http://www.weather.com.cn/m2/i/icon_weather/29x20/${weatherImg[1]}`" alt=""> -->
          <!-- 天气文字 -->
          <!-- <span style="margin-left:10px">{{weatherStr}}</span> -->
        </div>
      </a-col>

      <a-col :span="8">
        <h2 
          class="title"
          :style="{letterSpacing: lang === 'zh_CN' ? '5px' : '0px'}"
        >{{$t('dashboard.boardTitle')}}</h2>
      </a-col>

      <a-col :span="8">
        <div class="clock">{{clockStr}}</div>
      </a-col>
    </a-row>

    <!-- 系统基本数据统计面板 -->
    <a-row type="flex" style="padding: 30px 0 5px 0;">
      <a-col class="statistics-card-warp">
        <statistics-card 
          :title="$t('dashboard.registeredTxt')"
          chartIcon="icon_user.png"
          :cardData="user"
        />
      </a-col>
      <a-col class="statistics-card-warp">
        <statistics-card 
          :title="$t('dashboard.dailyTrafficTxt')"
          chartIcon="icon_person.png"
          :cardData="person"
        />
      </a-col>
      <a-col class="statistics-card-warp">
        <statistics-card 
          :title="$t('dashboard.dailyVisitorTxt')"
          chartIcon="icon_visitor.png"
          :cardData="visitor"
        />
      </a-col>
      <a-col class="statistics-card-warp">
        <statistics-card 
          :title="$t('dashboard.warningTxt')"
          chartIcon="icon_alarm.png"
          :cardData="alarm"
        />
      </a-col>
      <a-col class="statistics-card-warp">
        <statistics-card 
          :title="$t('dashboard.deviceTxt')"
          chartIcon="icon_device.png"
          :cardData="device"
        />
      </a-col>
    </a-row>

    <!-- 出入信息简要详情 -->
    <a-row style="height: calc(100% - 180px - 60px)">
      <a-col :span="6" style="padding: 10px;height: 100%">
        <!-- 访客信息 -->
        <info-warp :title="$t('dashboard.visitorInfoTitle')" :count="visitorRecordCount">
          <transition-group name="info-card" tag="div" class="info-card-group">
            <info-card
              height="33.333333%"
              style="flex-grow:1"
              width="100%"
              :showReason="true"
              v-for="(record, index) in visitorRecord"
              :key="record.id || record.uuid"
              :infoData="record"
            />
          </transition-group>
        </info-warp>
      </a-col>
      <a-col :span="10" style="padding: 10px;height: 100%">
        <!-- 出入信息 -->
        <info-warp :title="$t('dashboard.registeredInfoTitle')" :count="personRecordCount">
          <transition-group name="info-card" tag="div" class="info-card-group">
            <info-card 
              height="25%"
              width="50%"
              style="flex-grow:1"
              :showDirection="true"
              v-for="(record, index) in personRecord"
              :key="record.id || record.uuid"
              :infoData="record"
            />
          </transition-group> 
        </info-warp>
      </a-col>

      <!-- 人员、访客进入曲线图 -->
      <a-col :span="8" style="padding: 10px;height: 100%">
        <div style="height: 50%;padding-bottom:5px">
          <!-- 人员进出 -->
          <info-warp :title="$t('dashboard.registeredEntryExitTitle')" :showBottomBorder='false'>
            <!-- 按钮组和折线图标 -->
            <a-row class="operation-area" type="flex" justify="space-between" align="middle">
              <div class="btn-group">
                <span style="margin-right:30px">
                  <a-button size="small" :type="personDoorType === 1 ? 'primary' : ''" @click="handlePersonChangeDoorType(1)"> {{$t('dashboard.entryBtn')}} </a-button>
                  <a-button size="small" :type="personDoorType === 2 ? 'primary' : ''" @click="handlePersonChangeDoorType(2)"> {{$t('dashboard.exitBtn')}} </a-button>
                </span>
                <span>
                  <a-button size="small" :type="personDuration === 1 ? 'primary' : ''" @click="handlePersonChangeDuration(1)"> {{$t('dashboard.dailyBtn')}} </a-button>
                  <a-button size="small" :type="personDuration === 2 ? 'primary' : ''" @click="handlePersonChangeDuration(2)"> {{$t('dashboard.monthlyBtn')}} </a-button>
                </span>
              </div>
              <div>
                <span class="chart-legend today">{{ personLegend[0] }}</span>
                <span class="chart-legend yesterday">{{ personLegend[1] }}</span>
              </div>
            </a-row>
            <!-- 折线图 -->
            <div ref="lineChart" class="line-chart">
              <d-line-chart 
                v-show="personDuration === 1" 
                :height="lineChartHeight" 
                :lineData="personLineDataTime" 
                :labelFormat="timeLabelFormat"
              />
              <d-line-chart 
                v-show="personDuration === 2" 
                :height="lineChartHeight" 
                :lineData="personLineDataDay" 
                :labelFormat="dayLabelFormat"
              />
            </div>
          </info-warp>
        </div>
        <div style="height: 50%;padding-top:5px">
          <!-- 访客进出 -->
          <info-warp :title="$t('dashboard.visitorEntryExitTitle')" :showTopBorder='false'>
           <!-- 按钮组和折线图标 -->
            <a-row class="operation-area" type="flex" justify="space-between" align="middle">
              <div class="btn-group">
                <span style="margin-right:30px">
                  <a-button size="small" :type="visitorDoorType === 1 ? 'primary' : ''" @click="handleVisitorChangeDoorType(1)"> {{$t('dashboard.entryBtn')}} </a-button>
                  <a-button size="small" :type="visitorDoorType === 2 ? 'primary' : ''" @click="handleVisitorChangeDoorType(2)"> {{$t('dashboard.exitBtn')}} </a-button>
                </span>
                <span>
                  <a-button size="small" :type="visitorDuration === 1 ? 'primary' : ''" @click="handleVisitorChangeDuration(1)"> {{$t('dashboard.dailyBtn')}} </a-button>
                  <a-button size="small" :type="visitorDuration === 2 ? 'primary' : ''" @click="handleVisitorChangeDuration(2)"> {{$t('dashboard.monthlyBtn')}} </a-button>
                </span>
              </div>
              <div>
                <span class="chart-legend today">{{ visitorLegend[0] }}</span>
                <span class="chart-legend yesterday">{{ visitorLegend[1] }}</span>
              </div>
            </a-row>
            <!-- 折线图 -->
            <div ref="lineChart" class="line-chart">
              <d-line-chart 
                v-show="visitorDuration === 1" 
                :height="lineChartHeight" 
                :lineData="visitorLineDataTime" 
                :labelFormat="timeLabelFormat"
              />
              <d-line-chart 
                v-show="visitorDuration === 2" 
                :height="lineChartHeight" 
                :lineData="visitorLineDataDay" 
                :labelFormat="dayLabelFormat"
              />
            </div>
          </info-warp>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment';
import StatisticsCard from './components/StatisticsCard';
import InfoWarp from './components/InfoWarp';
import InfoCard from './components/InfoCard';
import DLineChart from './components/DLineChart';
import { getUuid } from '../../utils/utils';
import { getUserConfig } from '@/api/userMana';
import { 
  getCountOfDevice,
  getCountOfPerson,
  getCountOfRecogn,
  getCountOfPersonOpenRecogn,
  getCountOfVisitorOpenRecogn,
  getCountWarnning,
  getPersonalExtraInfo,
  getReservedExtraInfo,
  getVisitorExtraInfo
} from '@/api/statistics';
import { getRecognRecords } from '@/api/recognMana';
import { getWeather } from '@/api/common';

export default {
  name: 'dashboard',
  components: { StatisticsCard, InfoWarp, InfoCard, DLineChart },
  data () {
    return {
      clientHeight: document.body.clientHeight,
      lang: this.$store.state.lang,

      clockStr: '',
      weatherStr: '',
      weatherImg: [],

      // 模拟统计面板数据
      // 在册用户
      user: {
        count: 0,
        sub: []
      },
      // 今日人员
      person: {
        count: 0,
        sub: []
      },
      // 今日访客
      visitor: {
        count: 0,
        sub: []
      },
      // 今日预警
      alarm: {
        count: 0,
        sub: []
      },
      // 设备
      device: {
        count: 0,
        sub: []
      },

      personRecord: [], // 人员出入识别记录
      personRecordCount: 0,
      visitorRecord: [], // 访客出入识别记录
      visitorRecordCount: 0,

      lineChartHeight: 200,
      timeLabelFormat: null,
      dayLabelFormat: null,

      lineChartLegend: null,

      personLegend: null,
      personDoorType: 1, // 1： 进门；2：出门
      personDuration: 1, // 1：天；2：月
      personLineDataTime: null,
      personLineDataDay: null,

      visitorLegend: null,
      visitorDoorType: 1, // 1： 进门；2：出门
      visitorDuration: 1, // 1：天；2：月
      visitorLineDataTime: null,
      visitorLineDataDay: null,

      recordRefreshTimer: 10 * 1000,
      recordLineRefreshTimer: 60 * 1000,
      otherRefreshTimer: 60 * 1000      
    }
  },
  watch: {
    '$store.state.lang': function (lang) {
      this.lang = lang
      this.initChartTxt()
    }
  },
  computed: {},
  created() {
    this.initChartTxt()

    for (let i = 0; i < 8; i++) {
      this.personRecord.push({ uuid: getUuid() })
      if (i < 3) {
        this.visitorRecord.push({ uuid: getUuid() })
      }
    }

    setInterval(this.setClock, 1000)
    // this.getWeather()
    this.getRefreshTimer()

    this.getPersonStatistics()
    this.getInOutData()
    this.getWarningStatistics()
    this.getDeviceStatistics()

    this.getPersonLineSourceData(this.personDuration, this.personDoorType)
    this.getVisitorLineSourceData(this.visitorDuration, this.visitorDoorType)

    this.getPersonRecord()
    this.getVisitorRecord()
  },
  mounted() {
    this.lineChartHeight = this.$refs.lineChart.offsetHeight - 5
    window.onresize = () => {
      return (() => {
        this.lineChartHeight = this.$refs.lineChart.offsetHeight - 5
      })();
    };
  },
  methods: {
    // 获取刷新时间配置
    async getRefreshTimer() {
      try {
        const res = await getUserConfig()
        const {
          recordStatisticRefreshIntervalSecond,
          recordRefreshIntervalSecond,
          otherStatisticRefreshIntervalSecond
        } = res.data.collection[0]

        this.recordRefreshTimer = Number(recordStatisticRefreshIntervalSecond) * 1000
        this.recordLineRefreshTimer = Number(recordRefreshIntervalSecond) * 1000
        this.otherRefreshTimer = Number(otherStatisticRefreshIntervalSecond) * 1000
      } catch (error) {}
    },

    // 获取天气
    async getWeather() {
      try {
        const res = await getWeather({
          cityName: process.env.NODE_ENV === 'production' ? '' : '成都'
        })
        const { weatherinfo } = JSON.parse(res.data.collection[0])
        this.weatherStr = `${weatherinfo.weather} ${weatherinfo.temp1} ~ ${weatherinfo.temp2}`
        this.weatherImg.push(weatherinfo.img1, weatherinfo.img2)
      } catch (error) {}
    },
    
    // 时钟
    setClock() {
      const fomat = this.lang === 'zh_CN' 
        ? 'YYYY.MM.DD HH:mm:ss' : 'MMM Do YYYY, HH:mm:ss'
      this.clockStr = moment(new Date()).format(fomat)
    },

    /** ///////////////////////////// 数值统计 ///////////////////////////// */
    // 获取在册人员人数统计
    async getPersonStatistics() {
      try {
        const res = await getCountOfPerson()
        const data = res.data.collection[0]
        this.user = {          
          count: data.personAmount,
          unit: this.$t('dashboard.registeredUnit'),
          sub: [
            { title: this.$t('dashboard.registeredAuthed'), count: data.expiredPersonAmount },
            { title: this.$t('dashboard.registeredUnauthed'), count: data.personAmount - data.expiredPersonAmount }
          ]
        }
        setTimeout(this.getPersonStatistics, this.otherRefreshTimer)
      } catch (error) {
        if (error.response.status !== 401) {
          setTimeout(this.getPersonStatistics, this.otherRefreshTimer)
        }
      }
    },
    
    // 人员、访客今日进出门统计数据
    getInOutData() {
      Promise.all([
        this.personInOutCount(),
        this.visitorInOutCount(),
        this.inOutDataRequest()
      ]).then(res => {
        const personalCount = res[0].data.collection[0]
        const visitorCount = res[1].data.collection[0]
        const inOutRes = res[2].data.collection[0]

        let personIn = 0, personOut = 0, visitorIn = 0, visitorOut = 0;
        inOutRes.items.forEach(item => {          
          if (item.typeCode === 0) { // 人员
            if (item.typeCode2 === 1) { // 进门
              personIn += item.amount
            } else { // 出门
              personOut += item.amount
            }
          } else { // 预约访客、 临时访客、任何人
            if (item.typeCode2 === 1) { // 进门
              visitorIn += item.amount
            } else { // 出门
              visitorOut += item.amount
            }
          }
        })

        this.person = {
          count: personalCount,
          unit: this.$t('dashboard.trafficUnit'),
          sub: [
            { title: this.$t('dashboard.trafficEnter'), count: personIn },
            { title: this.$t('dashboard.trafficExit'), count: personOut }
          ]
        }        
        this.visitor = {
          count: visitorCount,
          unit: this.$t('dashboard.trafficUnit'),
          sub: [
            { title: this.$t('dashboard.trafficEnter'), count: visitorIn },
            { title: this.$t('dashboard.trafficExit'), count: visitorOut }
          ]
        }

        setTimeout(this.getInOutData, this.recordRefreshTimer)
      }).catch(error => {
        if (error.response.status !== 401) {
          setTimeout(this.getInOutData, this.recordRefreshTimer)
        }
      })
    },
    // 人员今日进出门总数
    personInOutCount() {
      return getCountOfPersonOpenRecogn({
        start: moment().format('YYYY-MM-DD') + ' 00:00:00',
        end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      })
    },
    // 访客今日进出门总数
    visitorInOutCount() {
      return getCountOfVisitorOpenRecogn({
        start: moment().format('YYYY-MM-DD') + ' 00:00:00',
        end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
      })
    },

    // 预警数据统计
    async getWarningStatistics() {
      try {
        const res = await getCountWarnning({
          start: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
          end: moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        })
        const data = res.data.collection[0]
        let strangerCount = 0, blackCount = 0;        
        data.items.forEach(item => {          
          if (item.typeCode === 1) { // 陌生人预警
            strangerCount += item.amount
          } else if (item.typeCode === 2) { // 黑名单预警
            blackCount += item.amount
          }
        })
        this.alarm = {
          count: strangerCount + blackCount,
          unit: this.$t('dashboard.warningUnit'),
          sub: [
            { title: this.$t('dashboard.warningStranger'), count: strangerCount },
            { title: this.$t('dashboard.warningBlacklist'), count: blackCount }
          ]
        }
        setTimeout(this.getWarningStatistics, this.otherRefreshTimer)
      } catch (error) {
        if (error.response.status !== 401) {
          setTimeout(this.getWarningStatistics, this.otherRefreshTimer)
        }        
      }
    },
    // 设备数据统计
    async getDeviceStatistics() {
      try {
        const res = await getCountOfDevice()
        const data = res.data.collection[0]
        this.device = {
          count: data.deviceAmount,
          unit: this.$t('dashboard.deviceUnit'),
          sub: [
            { title: this.$t('dashboard.deviceOnline'), count: data.deviceOnlineAmount },
            { title: this.$t('dashboard.deviceOffline'), count: data.deviceAmount - data.deviceOnlineAmount }
          ]
        }
        setTimeout(this.getDeviceStatistics, this.otherRefreshTimer)
      } catch (error) {
        if (error.response.status !== 401) {
          setTimeout(this.getDeviceStatistics, this.otherRefreshTimer)
        }
      }
    },
    
    /** ///////////////////////////// 访客、人员出入简要详情 ///////////////////////////// */
    // 人员出入记录
    async getPersonRecord() {
      try {
        // 识别信息请求
        const res = await getRecognRecords({
          start: moment().format('YYYY-MM-DD') + ' 00:00:00',
          end: moment().format('YYYY-MM-DD') + ' 23:59:59',
          page: 1,
          perPage: 8,
          authTargetTypeCodes: [0]
        })
        this.personRecordCount = res.data.size

        const data = res.data.collection
        for (let i = 0, l = data.length; i < l; i++) {
          if (!this.personRecord[i].id || data[i].id !== this.personRecord[i].id) {
            // 人员补充信息请求
            const res = await getPersonalExtraInfo({ id: data[i].id })
            data[i] = Object.assign(data[i], { personPhotoUrl: res.data.collection[0].scenePhotoUrl })
          
            this.personRecord.splice(i, 1, data[i])
          }
        }

        setTimeout(this.getPersonRecord, this.recordRefreshTimer)
      } catch (error) {
        if (error.response.status !== 401) {
          setTimeout(this.getPersonRecord, this.recordRefreshTimer)
        }
      }      
    },
    // 访客出入记录
    async getVisitorRecord() {
      try {
        // 识别信息请求
        const res = await getRecognRecords({
          start: moment().format('YYYY-MM-DD') + ' 00:00:00',
          end: moment().format('YYYY-MM-DD') + ' 23:59:59',
          page: 1,
          perPage: 3,
          authTargetTypeCodes: [1, 2]          
        })
        this.visitorRecordCount = res.data.size
        const data = res.data.collection        
        for (let i = 0, l = data.length; i < l; i++) {
          if (!this.visitorRecord[i].id || data[i].id !== this.visitorRecord[i].id) {
            const res = data[i].authTargetTypeCode === 1 
              // 预约访客补充信息请求
              ? await getReservedExtraInfo({ id: data[i].id })
              // 访客补充信息请求
              : await getVisitorExtraInfo({ id: data[i].id })
            data[i] = Object.assign(data[i], { 
              reason: res.data.collection[0].reason,
              personPhotoUrl: res.data.collection[0].scenePhotoUrl
            })

            this.visitorRecord.splice(i, 1, data[i])
          }
        }
        setTimeout(this.getVisitorRecord, this.recordRefreshTimer)
      } catch (error) {
        if (error.response.status !== 401) {
          setTimeout(this.getVisitorRecord, this.recordRefreshTimer)
        }
      }
    },
    
    /** ///////////////////////////// 人员进出折线图数据 ///////////////////////////// */
    // 获取人员进出门数据
    // duration 时间段类型 1：天；2：月
    // doorType 进出类型 1：进门；2：出门
    getPersonLineSourceData(duration, doorType) {
      this.getLineSourceData(duration).then(resArr => {
        // 设置人员今日\本月的折线图数据源
        this.personLineSourceData = this.setLineSourceData(
          duration, 
          resArr[0].data.collection, 
          this.personLegend[0], 
          [0]
        )
        // 设置人员昨日\上月的折线图数据源
        this.personLineSourceDataContrast = this.setLineSourceData(
          duration, 
          resArr[1].data.collection, 
          this.personLegend[1], 
          [0]
        )

        // 设置人员折线图数据
        this.setPersonLineData(duration, doorType)

        this.personLineTimer = setTimeout(() => {
          this.getPersonLineSourceData(duration, doorType)
        }, this.recordLineRefreshTimer)
      }).catch(error => {
        if (error.response.status !== 401) {
          this.personLineTimer = setTimeout(() => {
            this.getPersonLineSourceData(duration, doorType)
          }, this.recordLineRefreshTimer)
        }
      })
    },    
    // 设置人员折线图数据
    setPersonLineData(duration, doorType) {
      const doorTypeName = doorType === 1 ? 'in' : 'out'
      const sourceData = this.personLineSourceData.map(item => {
        return { ...item[doorTypeName], doorType }
      })
      const sourceDataContrast = this.personLineSourceDataContrast.map(item => {
        return { ...item[doorTypeName], doorType }
      })
      if (duration === 1) {
        this.personLineDataTime = [].concat(sourceData, sourceDataContrast)
      }
      if (duration === 2) {
        this.personLineDataDay = [].concat(sourceData, sourceDataContrast)
      }
    },
    // 改变人员进出门折线图开门方向
    handlePersonChangeDoorType(type) {
      this.personDoorType = type
      if (this.personLineSourceData && this.personLineSourceDataContrast) {
        this.setPersonLineData(this.personDuration, type)
      }  
    },
    // 改变人员进出门折线图统计时间段
    handlePersonChangeDuration(type) {
      this.personDuration = type
      this.personLegend = type === 1 ? this.lineChartLegend.day : this.lineChartLegend.month

      if (this.personLineTimer) {
        clearTimeout(this.personLineTimer)
        this.personLineTimer = null
      }
      
      this.getPersonLineSourceData(type, this.personDoorType)
    },
    
    /** ///////////////////////////// 访客进出折线图数据 ///////////////////////////// */
    // 请求访客进出门数据
    getVisitorLineSourceData(duration, doorType) {
      
      this.getLineSourceData(duration).then(resArr => {
        // 设置访客今日\本月的折线图数据源
        this.visitorLineSourceData = this.setLineSourceData(
          duration, 
          resArr[0].data.collection, 
          this.visitorLegend[0], 
          [1, 2]
        )
        // 设置人员昨日\上月的折线图数据源
        this.visitorLineSourceDataContrast = this.setLineSourceData(
          duration, 
          resArr[1].data.collection, 
          this.visitorLegend[1],
          [1, 2]
        )
        // 设置访客折线图数据
        this.setVisitorLineData(duration, doorType)

        this.visitorLineTimer = setTimeout(() => {
          this.getVisitorLineSourceData(duration, doorType)
        }, this.recordLineRefreshTimer)
      }).catch(error => {
        if (error.response.status !== 401) {
          this.visitorLineTimer = setTimeout(() => {
            this.getVisitorLineSourceData(duration, doorType)
          }, this.recordLineRefreshTimer)
        }
        
      })
    },
    // 设置访客折线图数据
    setVisitorLineData(duration, doorType) {
      const doorTypeName = doorType === 1 ? 'in' : 'out'
      const sourceData = this.visitorLineSourceData.map(item => item[doorTypeName])
      const sourceDataContrast = this.visitorLineSourceDataContrast.map(item => item[doorTypeName])

      if (duration === 1) {
        this.visitorLineDataTime = [].concat(sourceData, sourceDataContrast)
      }
      if (duration === 2) {
        this.visitorLineDataDay = [].concat(sourceData, sourceDataContrast)
      }
    },
    // 改变访客进出门折线图开门方向
    handleVisitorChangeDoorType(type) {
      this.visitorDoorType = type
      if (this.visitorLineSourceData && this.visitorLineSourceDataContrast) {
        this.setVisitorLineData(this.visitorDuration, type)
      }
    },
    // 改变访客进出门折线图统计时间段
    handleVisitorChangeDuration(type) {
      this.visitorDuration = type
      this.visitorLegend = type === 1 ? this.lineChartLegend.day : this.lineChartLegend.month

      if (this.visitorLineTimer) {
        clearTimeout(this.visitorLineTimer)
        this.visitorLineTimer = null
      }

      this.getVisitorLineSourceData(type, this.visitorDoorType)
    },

    /** ///////////////////////////// 人员、访客进出折线图公共方法 ///////////////////////////// */
    // 人员、访客进出门统计数的请求方法
    inOutDataRequest(data) {
      return getCountOfRecogn({
        start: moment().format('YYYY-MM-DD') + ' 00:00:00',
        end: moment().format('YYYY-MM-DD') + ' 23:59:59',
        ...data
      })
    },    
    // 获取人员、访客进出门数据
    // duration 时间段类型 1：天；2：月
    // doorType 进出类型 1：进门；2：出门
    getLineSourceData(duration) {
      const durationData = this.getDuration(duration)
      const durationDataContrast = this.getDuration(duration, 1)
      let intervalSecond = duration === 1 ? 3600 : 86400

      // 请求数据并返回
      return Promise.all([
        this.inOutDataRequest({ ...durationData, intervalSecond }),
        this.inOutDataRequest({ ...durationDataContrast, intervalSecond })
      ])
    },
    // 获取时间段
    // durationType 1：一天、2：一月
    // offset 相对于今天（本月）向以前时间的偏移量，如 0 即为今日（本月）、1 即为昨日（上月）...
    getDuration(durationType, offset = 0) {
      let start, end
      if (durationType === 1) {
        start = moment().subtract(offset, 'day').format('YYYY-MM-DD') + ' 00:00:00'
        end = moment().subtract(offset, 'day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        start = moment().subtract(offset, 'month').startOf('month').format('YYYY-MM-DD') + ' 00:00:00'
        end = moment().subtract(offset, 'month').endOf('month').format('YYYY-MM-DD') + ' 23:59:59'
      }
      return { start, end }
    },
    // 设置人员或访客进出折线图数据源
    // durationType 时间段 1: 天；2：月
    // data 请求返回的数据集
    // sourceDataType 今日\昨日；本月\上月
    // lineType 数组形式 0: 人员； 1：预约访客；2：临时访客；9：任何人
    setLineSourceData(durationType, data, sourceDataType, lineType) {
      let sourceData
      if (durationType === 1) {
        sourceData = new Array(24)
      } else {
        sourceData = new Array(31)
      }

      for (let i = 0, l = sourceData.length; i < l; i++) {
        sourceData[i] = {
          in: { date: this.setDate(durationType, String(i + 1)), type: sourceDataType, value: 0 },
          out: { date: this.setDate(durationType, String(i + 1)), type: sourceDataType, value: 0 }
          // in: { date: String(i + 1), type: sourceDataType, value: 0 },
          // out: { date: String(i + 1), type: sourceDataType, value: 0 }
        }

        const dataItems = data[i] ? data[i].items : []
        dataItems.forEach(item => {
          if (lineType.includes(item.typeCode)) {
            if (item.typeCode2 === 1) { // 进门
              sourceData[i].in.value += item.amount
            } else { // 出门
              sourceData[i].out.value += item.amount
            }
          }
        })
      }
      return sourceData
    },
    // 处理数据项的时间描述
    setDate(durationType, val) {
      if (durationType === 1) {
        return `${Number(val) - 1} ${this.$t('dashboard.oClock')} - ${val} ${this.$t('dashboard.oClock')}`
      } else {
        return `${val}${this.$t('dashboard.day')}`
      }
    },
    // 折线图横轴显示内容处理
    initChartTxt() {
      this.timeLabelFormat = text => text.match(/\d{1,}/g)[1]
      this.dayLabelFormat = text => text.match(/\d{1,}/g)[0]

      this.lineChartLegend = {
        day: [this.$t('dashboard.today'), this.$t('dashboard.yesterday')],
        month: [this.$t('dashboard.thisMonth'), this.$t('dashboard.lastMonth')]
      }

      this.personLegend = this.visitorLegend = this.lineChartLegend.day
    }
  }
}
</script>

<style lang="less" scoped>
  @font-face {
    font-family: ElectronicFont;
    src: url('../../assets/fonts/DS-Digital/DS-DIGIT.ttf'), url(../../assets/fonts/DS-Digital/DS-DIGII.ttf), url(../../assets/fonts/DS-Digital/DS-DIGIB.ttf), url(../../assets/fonts/DS-Digital/DS-DIGI.ttf)
  }
  // 禁用复制
  *{
    -webkit-touch-callout:none;/*系统默认菜单被禁用*/
    -webkit-user-select:none;/*webkit浏览器*/
    -khtml-user-select:none;/*早期浏览器*/
    -moz-user-select:none;/*火狐*/
    -ms-user-select:none;/*IE10*/
    user-select:none;
  }
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url('../../assets/dashboard/dashboard_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 1920px;
    min-height: 900px;
    padding: 0 20px 10px 20px;
    color: white;
    
  }
  .page-head {
    font-weight: bold;
    .weather {
      line-height: 50px;
      font-weight: bold;
      padding-left: 80px;
    }
    .title {
      background: linear-gradient(to bottom, #fff, #aad4fe);
      background-clip: text;
      color: transparent;

      text-align: center;
      letter-spacing: 5px;
      font-weight: bold;
      margin-bottom: 0;
      font-size: 32px;
      line-height: 65px;     
    }
    .clock{
      font-size: 22px;
      line-height: 50px;
      font-weight: bold;
      padding-right: 80px;
      text-align: right;
      font-family: ElectronicFont;
      letter-spacing: 2px;
    }
  }

  .statistics-card-warp {
    height: 140px;
    width: 20%;
    padding: 0 10px;
  }

  .operation-area{
    padding: 10px 25px;

    .btn-group .ant-btn-sm{
      font-size: 12px;
      width: 56px;
      color: #3c82eb;
      border-color: #3060c4;
      background-color: transparent;
      margin-right: 5px;
    }
    .btn-group .ant-btn-primary{
      color: #fff;
      background-color: #022c6c;
      border-color: #022c6c;
    }
    .chart-legend{
      font-size: 12px;
      margin-left: 30px;
      position: relative;
    }
    .chart-legend:before{
      content: '';
      width: 11px;
      height: 11px;
      border-radius: 50%;
      position: absolute;
      left: -15px;
      top: 1px;
    }
    .chart-legend.today:before{
      background-color: #642af7;
      border: solid 1px #ddb6ff;    
    }
    .chart-legend.yesterday:before{
      background-color: #22e1db;
      border: solid 1px #80fffb;
    }
  }

  .line-chart{
    width: 100;
    height: calc(100% - 44px);
    position: relative;
  }

  .info-card-group{
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .info-card-enter-active {
    transition: all 1s;
  }
  .info-card-enter {
    opacity: 0;
    transform: rotateX(180deg);
  }
</style>
